if (!customElements.get("footer-details")) {
  class FooterDetails extends AccordionDetails {
    constructor() {
      super();
    }
    
    connectedCallback() {
      this.openDefault = this.dataset.openDefault === 'true';

      if (FoxTheme.config.mqlTablet) {
        if (!this.openDefault) this.open = false;
      }

      document.addEventListener('matchTablet', () => {
        if (!this.openDefault) {
          this.open = false;
        } else {
          this.open = true;
        }
      });

      document.addEventListener('unmatchTablet', () => {
        this.open = true;
      });
    }
  }
  customElements.define('footer-details', FooterDetails, { extends: 'details' });
}

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-cookie-preferences]');

  if (
    !trigger ||
    event.defaultPrevented ||
    event.button !== 0 ||
    event.metaKey ||
    event.ctrlKey ||
    event.shiftKey ||
    event.altKey
  ) {
    return;
  }

  const cookieBanner = window.privacyBanner;

  if (!cookieBanner || typeof cookieBanner.showPreferences !== 'function') {
    return;
  }

  event.preventDefault();

  Promise.resolve(cookieBanner.showPreferences()).catch(() => {
    window.location.assign(trigger.href);
  });
});
